import(/* webpackMode: "eager" */ "/data/www/vetopedia.org/frontend/app/layout.tsx");
